import { useEffect } from "react";
import { tokens } from "../styles/tokens";

const STYLE_ID = "react-smart-loading-effects-styles";

const CSS = `
@keyframes rsle-shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}
.rsle-skeleton {
  position: relative;
  overflow: hidden;
  background-color: var(--rsle-bg, ${tokens.bg});
}
.rsle-skeleton--animated::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    var(--rsle-shimmer, ${tokens.shimmer}) 50%,
    transparent 100%
  );
  transform: translateX(-100%);
  animation: rsle-shimmer 1.5s ease-in-out infinite;
  will-change: transform;
}
`;

export function ShimmerStyles() {
  useEffect(() => {
    if (typeof document === "undefined") return;
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = CSS;
    document.head.appendChild(style);
  }, []);

  return null;
}
